// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"style-module--pageWrap--2W6Dz","headWrap":"style-module--head-wrap--2Kz_J","content":"style-module--content--JYlFF"};